import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import Club from '../list/club';
import ClubSupervisor from '../list/club/supervisor';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { corvertQuery } from '@/modules/UserEventLanding/functions';
import ClubMember from '../list/club/member';

const API_PATH = 'clubs';
const API_PATH_SUPERVISORS = 'club-supervisors';

const API_PATH_INVITE  = 'club-invites';
const API_PATH_SUPERVISORS_INVITE = 'club-supervisor-invites';

export const ClubManager = {
  objects: {
    ...objectsRHandler(API_PATH, Club),
    showInvite({ data, params } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.post(`/${API_PATH_INVITE}/show-info${corvertQuery(params)}`, data),
        (response) => ({
          response,
          item: new Club(response.data.data),
        }),
        (error) => ({ error }),
      );
    },
    acceptInvite({ data } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.post(`/${API_PATH_INVITE}/accept`, data), // { invite }
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
    changeOwner({ args, data } = DEFAULT_PARAMS) {
      const [clubId] = args;
      return rHandler(
        apiService.post(`/${API_PATH}/${clubId}/change-owner`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
  },
  supervisors: {
    ...objectsRHandler(API_PATH_SUPERVISORS, ClubSupervisor),
    detach({ args } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.delete(`/${API_PATH_SUPERVISORS}/${id}/detach`),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
    showInvite({ data, params } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.post(`/${API_PATH_SUPERVISORS_INVITE}/show-info${corvertQuery(params)}`, data),
        (response) => ({
          response,
          item: new ClubSupervisor(response.data.data),
        }),
        (error) => ({ error }),
      );
    },
    acceptInvite({ data } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.post(`/${API_PATH_SUPERVISORS_INVITE}/accept`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
  },
  get members() {
    const list = ({ args, params } = DEFAULT_PARAMS) => {
      const [clubId] = args;
      return rHandler(
        apiService.get(`/${API_PATH}/${clubId}/members`, params),
        (response) => ({
          response,
          items: (response.data.data || []).map((i) => new ClubMember(i)),
        }),
        (error) => ({ error }),
      );
    };
    const listManage = ({ args, params } = DEFAULT_PARAMS) => {
      const [clubId] = args;
      return rHandler(
        apiService.get(`/${API_PATH}/${clubId}/members/manage`, params),
        (response) => ({
          response,
          items: (response.data.data || []).map((i) => new ClubMember(i)),
        }),
        (error) => ({ error }),
      );
    };
    return {
      list,
      listManage,
      index({ args, params } = DEFAULT_PARAMS) {
        const { manage, ...other } = params;
        if (manage) return listManage({ args, params: { ...other } });
        return list({ args, params: { ...other } });
      },
      confirm({ args, data } = DEFAULT_PARAMS) {
        const [clubId] = args;
        return rHandler(
          apiService.post(`/${API_PATH}/${clubId}/members/confirm`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
      reject({ args, data } = DEFAULT_PARAMS) {
        const [clubId] = args;
        return rHandler(
          apiService.post(`/${API_PATH}/${clubId}/members/reject`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
    };
  },
};
